import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBanner from '../../components/ContentBanner';
import ContactMenu from '../../components/menus/Contact';
import MapSection from './MapSection';

function Directions({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className="">
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
      />
      <ContactMenu />
      <ContentBanner
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      />
      <div className="container">
        <MapSection page={page} />
      </div>
    </PageWrapper>
  );
}

Directions.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'directions',
})(Directions);



// WEBPACK FOOTER //
// ./src/pages/Directions/index.js